export var PersonType = /*#__PURE__*/function (PersonType) {
  PersonType["Customer"] = "CUSTOMER";
  PersonType["Team Member"] = "EMPLOYEE";
  PersonType["Investor"] = "INVESTOR";
  PersonType["Commercial"] = "COMMERCIAL";
  PersonType["Trade Partner"] = "TRADE PARTNER";
  return PersonType;
}(PersonType || {});
export const PersonTypes = Object.freeze(Object.keys(PersonType));
